module.exports = __webpack_public_path__ + "assets/img/INTERIOR13.8d8a35be.png";